import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "offline-notification"
}
const _hoisted_2 = {
  key: 1,
  class: "sync-notification"
}
const _hoisted_3 = { class: "sync-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isOnline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "offline-content" }, [
            _createElementVNode("i", {
              class: "pi pi-wifi",
              style: {"color":"red"}
            }),
            _createElementVNode("span", null, "You are currently offline. Some features may be limited.")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.showSyncNotification)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("i", {
              class: _normalizeClass(["pi pi-sync", { 'pi-spin': _ctx.isSyncing }])
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(_ctx.syncMessage), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}